import { type ReactNode } from "react";

// TENAX: bottom padding grows with the iPhone home bar inset (task 1.12)
export const MobileContent = ({ children }: { children: ReactNode }) => (
  <main
    className="max-w-screen-xl mx-auto pt-18 px-4 pb-[calc(5rem+env(safe-area-inset-bottom))] min-h-screen overflow-y-auto"
    id="main-content"
  >
    {children}
  </main>
);
